import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const githubFolderPickerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'github-folder-picker-form-field-extension',
    params: {
      field: () =>
        import('./github-folder-picker').then(
          m => m.GithubFolderPickerFormField,
        ),
    },
  });
